/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown>, index: NonNullable<unknown> }} Ai_Event_Group_NameInputs */

const en_ai_event_group_name = /** @type {(inputs: Ai_Event_Group_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
};

const fr_ai_event_group_name = /** @type {(inputs: Ai_Event_Group_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`IA ${i?.type} 0${i?.index}`)
};

const de_ai_event_group_name = /** @type {(inputs: Ai_Event_Group_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
};

const it_ai_event_group_name = /** @type {(inputs: Ai_Event_Group_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
};

const ru_ai_event_group_name = /** @type {(inputs: Ai_Event_Group_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
};

const es_ai_event_group_name = /** @type {(inputs: Ai_Event_Group_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`IA ${i?.type} 0${i?.index}`)
};

const zh_cn2_ai_event_group_name = /** @type {(inputs: Ai_Event_Group_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
};

const ja_ai_event_group_name = /** @type {(inputs: Ai_Event_Group_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
};

const hi_ai_event_group_name = /** @type {(inputs: Ai_Event_Group_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`एआई __पीएच_0__ 0__पीएच_1__`)
};

const pt_pt2_ai_event_group_name = /** @type {(inputs: Ai_Event_Group_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`IA ${i?.type} 0${i?.index}`)
};

/**
* | output |
* | --- |
* | "AI {type} 0{index}" |
*
* @param {Ai_Event_Group_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_event_group_name = /** @type {((inputs: Ai_Event_Group_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Event_Group_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ai_event_group_name(inputs)
	if (locale === "de") return de_ai_event_group_name(inputs)
	if (locale === "it") return it_ai_event_group_name(inputs)
	if (locale === "ru") return ru_ai_event_group_name(inputs)
	if (locale === "es") return es_ai_event_group_name(inputs)
	if (locale === "zh-CN") return zh_cn2_ai_event_group_name(inputs)
	if (locale === "ja") return ja_ai_event_group_name(inputs)
	if (locale === "hi") return hi_ai_event_group_name(inputs)
	if (locale === "pt-PT") return pt_pt2_ai_event_group_name(inputs)
	return en_ai_event_group_name(inputs)
});